// takes an object with snake cased keys and transforms it to camelCase keys
// only transforms the root level keys
// if the key is just _ it wont transform it, if _ is the last character it removes it
export function snakeCaseToCamelCase(snakeCaseObject) {
  const camelCaseObject = {};
  Object.keys(snakeCaseObject).forEach(key => {
    let camelCaseKey = key;
    while (camelCaseKey.indexOf('_') > -1) {
      const underscoreIndex = camelCaseKey.indexOf('_');
      if (underscoreIndex < camelCaseKey.length - 1) {
        camelCaseKey = camelCaseKey.slice(0, underscoreIndex) + camelCaseKey.charAt(underscoreIndex + 1).toUpperCase() + camelCaseKey.slice(underscoreIndex + 2);
      } else if (camelCaseKey.length !== 1) {
        camelCaseKey = camelCaseKey.slice(0, camelCaseKey.length - 1);
      } else {
        break;
      }
    }
    camelCaseObject[camelCaseKey] = snakeCaseObject[key];
  });

  return camelCaseObject;
}
